import { Cell } from '@/grid/Cell';

export interface AlgorithmStep {
  type: 'explore' | 'open' | 'close' | 'path_found' | 'path_backtrack';
  cell: Cell;
  cost?: number;
  parent?: Cell;
  openListSize: number;
  closedListSize: number;
  metadata?: Record<string, any>;
}

export class PathResult {
  public readonly path: Cell[];
  public readonly nodesExplored: number;
  public readonly executionTime: number;
  public readonly success: boolean;
  public readonly steps: AlgorithmStep[];

  constructor(
    path: Cell[],
    nodesExplored: number,
    executionTime: number,
    success: boolean,
    steps: AlgorithmStep[] = []
  ) {
    this.path = path;
    this.nodesExplored = nodesExplored;
    this.executionTime = executionTime;
    this.success = success;
    this.steps = steps;
  }

  get pathLength(): number {
    return this.path.length;
  }

  static failure(nodesExplored: number, executionTime: number, steps: AlgorithmStep[] = []): PathResult {
    return new PathResult([], nodesExplored, executionTime, false, steps);
  }
}
